import React from "react";
import CloseIcon from "../Assets/svgs/CloseIcon";
import WarningAlertIcon from "../Assets/svgs/WarningAlertIcon";
import { useNavigate } from "react-router-dom";

// "BUY_ASSISTANT", "MAX_ASSISTANT_REACHED", "UPGRADE_PLAN"
const BuyAdditionalAssistantModal = ({
  onClose,
  type,
  maxAssistant,
  assistantAmount,
}) => {
  const navigate = useNavigate();

  const onClickUpgradePlan = () => {
    navigate("/subscription");
    onClose();
  };

  const onClickPurchaseAssistant = () => {
    navigate("/additional-assistant-payment", {
      state: {
        maxAssistant,
        assistantAmount,
      },
    });
    onClose();
  };

  return (
    <div className="modal modal--modalCredits modal--open">
      <div className="modal__dialog">
        <div className="modal__content modal__content--md">
          <div className="modal__header">
            <button className="btn btn__transparent btnClose" onClick={onClose}>
              <CloseIcon />
            </button>
          </div>
          <div className="modal__body">
            <span className="icon icon--mb5">
              <WarningAlertIcon />
            </span>
            <h4 className="title title--h3 title--black">Max Limit Reached</h4>
            <p className="para">
              {type == "BUY_ASSISTANT"
                ? "You’ve reached maximum number of assistants for your plan, Kindly buy additional assistants to continue"
                : type == "UPGRADE_PLAN"
                ? "You’ve reached maximum number of assistants for your plan, Kindly upgrade your plan to continue"
                : "You’ve reached maximum number of assistants for your plan."}
            </p>
          </div>
          <div className="modal__footer">
            <div className="btn__group">
              <button
                className="btn btn__primary btn--full"
                onClick={
                  type == "BUY_ASSISTANT"
                    ? onClickPurchaseAssistant
                    : onClickUpgradePlan
                }
              >
                {type == "BUY_ASSISTANT"
                  ? "Buy Additional Assistants"
                  : "Upgrade Your Plan"}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal__backdrop"></div>
    </div>
  );
};

export default BuyAdditionalAssistantModal;
